import React from "react";
import { useT } from "@/lib/LanguageContext";
import useNudges from "../hooks/useNudges";
import SectionHeading from "../ui/SectionHeading";
import EmptyState from "../ui/EmptyState";
import CrmButton from "../ui/CrmButton";
import CrmPager from "../ui/CrmPager";
import CrmLoadFailure from "../ui/CrmLoadFailure";
import NudgeCard from "./NudgeCard";
import { CRM } from "../../../constants/testIds/crm";

/**
 * Zone 2, Nudges — "stacked list, max 5, Show all link" (spec). Show all expands the
 * list IN PLACE (the page does not change) and pages it when it outgrows one page.
 * Fails on its own, like the other two zones.
 */
export default function NudgeList() {
  const t = useT("crm");
  const { rows, total, page, pageSize, setPage, loaded, loadError, reload, showAll, setShowAll, act, dismiss } = useNudges();
  return (
    <section aria-labelledby="crm-nudges-heading" data-testid={CRM.nudgeList}>
      <SectionHeading
        id="crm-nudges-heading"
        title={t("nudges.title")}
        right={!showAll && total > rows.length && (
          <CrmButton variant="link" size="sm" className="font-body font-normal underline" onClick={() => setShowAll(true)} data-testid={CRM.nudgeShowAll}>
            {t("nudges.showAll")}
          </CrmButton>
        )}
      />
      {loadError && <CrmLoadFailure error={loadError} onRetry={reload} testId="crm-nudge-error" />}
      {loaded && !loadError && rows.length === 0 && <EmptyState testId={CRM.nudgeEmpty} title={t("nudges.empty")} />}
      {rows.length > 0 && (
        <ul className="space-y-3">
          {rows.map((n) => <li key={n.id}><NudgeCard nudge={n} onAct={act} onDismiss={dismiss} /></li>)}
        </ul>
      )}
      {showAll && total > pageSize && <CrmPager page={page} pageSize={pageSize} total={total} onPage={setPage} testId={CRM.nudgePager} />}
    </section>
  );
}
